import Badge from '@mui/material/Badge';
import { styled } from '@mui/material/styles';

const SmallBadge = styled(Badge)(({ theme }) => ({
  '& .MuiBadge-badge': {
    minWidth: '16px',
    height: '16px',
    padding: 0,
  },
}));

export default SmallBadge;
